import { render, staticRenderFns } from "./document-item-list.vue?vue&type=template&id=6e803794&scoped=true"
import script from "./document-item-list.vue?vue&type=script&lang=js"
export * from "./document-item-list.vue?vue&type=script&lang=js"
import style0 from "./document-item-list.vue?vue&type=style&index=0&id=6e803794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e803794",
  null
  
)

export default component.exports